module.exports = __webpack_public_path__ + "static/media/LoanMehrStep3.dee75647.png";